<template>
    <div>
        <img class="arrow left" src="/images/blog/left-arrow.png" @click="moveItem('left')">
        <img class="arrow right" src="/images/blog/right-arrow.png" @click="moveItem('right')">
        <div class="related-row">
            <div :class="'related-content card_' + currentItem">
                <template v-if="!loading && blogs.length == 0">
                    <p class="centered"></p>
                </template>
                <template v-else>
                    <div v-if="loading">
                        <div >
                            <div class="loader"></div>
                        </div>
                    </div>
                    <template v-if="!loading" >
                        <div class="related-item" v-for="(blogsItem, index) in blogs" :key="blogsItem.permalink">
                            <div class="related-item-card">
                                <div class="img-container" v-if="blogsItem.hero_image_url">
                                    <img :src="blogsItem.hero_image_url" class="razred-image" @click="openBlogs(blogsItem, index+1)" >
                                </div>
                                <div class="razred-no-image" v-else></div>
                                <div class="txt-container">
                                    <a class="header" @click="openBlogs(blogsItem, index+1)">{{blogsItem.title}}</a>
                                    <div class="description" v-if="blogsItem.excerpt" v-html="shortenExcerpt(blogsItem.excerpt)"></div>
                                </div>
                            </div>
                            <div class="pink-btn-container">
                                <a target="_blank" class="izzi-button pink" @click="openBlogs(blogsItem)">Preberi</a>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ["existingBlog"],
    data() {
        return {
            activeFilter: null,
            currentItem: 1,
            loading: true,
            subjects: undefined,
			blogs: []
        }
	},
    mounted() {
        this.loadBlogs();
    },
    methods: {
        loadBlogs() {
            axios.get(this.route('warehouse.blogs.all')).then(({data}) => {
                this.loading = false
                this.subjects = data.subjects
                // cross filter categories
                const relatedContent = data.news.filter(item => !item.hidden && item.permalink !== this.existingBlog.permalink && !!this.existingBlog.category.split(",").filter(singleNewsCategory => item.category.split(",").indexOf(singleNewsCategory) > -1).length);
                const shuffeledRelatedContent = relatedContent.sort(() => {
                    const randomTrueOrFalse = Math.random() > 0.5;
                    return randomTrueOrFalse ? 1 : -1
                });
                this.blogs = shuffeledRelatedContent;
            })
        },
        moveItem(direction) {
            if (direction === 'left') {
                this.currentItem > 1 ? this.currentItem-- : "";
            } else {
                this.currentItem < this.blogs.length ? this.currentItem++ : "";
            }
        },
		openBlogs(blogsItem, index) {
			let url = this.route('warehouse.blogs.single', blogsItem.permalink);
            this.currentRelatedItem = index;
            location = url;
		},
        shortenExcerpt(excerpt) {
            return excerpt && excerpt.length > 200 ? excerpt.slice(0,200).concat('...') : excerpt;
        }
	}
};
</script>
